import react, { useReducer, useMemo } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { InputLabel, Box, FormControl, Select, MenuItem, TextField } from '@mui/material'
import { number2dayweek } from '../../Utils/dayjsptbrhelper'
import ColorButton from '../../Buttons/ColorButton'
import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers'
import { incentivos } from './entrada'
import Table from '../../Table'

const initial_state = {
    apuracao_ini: '',
    apuracao_end: '',
    inventario_date: '',
    datefilter: '',
    numeronf: '',
    tipoincentivo: '',
    codpro: '',
    rows: [],
    edit: null
}

const getcolumns = () => {
    const columns = []
    columns.push({field: 'codigo', headerName: 'Código'})
    columns.push({field: 'ncm', headerName: 'NCM', width: 5})
    columns.push({field: 'codpro', headerName: 'Produto'})
    columns.push({field: 'numnfserie', headerName: 'Núm. NF', width: 5})
    columns.push({field: 'serie', headerName: 'Sér'})
    columns.push({field: 'saldoant', headerName: 'Saldo Ant.', flex: 1})
    columns.push({field: 'qtdeentr', headerName: 'Qtde Entr.'})
    columns.push({field: 'qtdesaidade', headerName: 'Qtde Saída DE', flex: 1})
    columns.push({field: 'qtdesaidafe', headerName: 'Qtde Saida FE'})
    columns.push({field: 'qtdesaioutras', headerName: 'Qtde Sai Outras'})
    columns.push({field: 'saldoproxmes', headerName: 'Saldo Prox. Mês'})
    columns.push({field: 'precocusto', headerName: 'Preço Custo'})
    columns.push({field: 'customtotalde', headerName: 'Custo Total DE'})
    columns.push({field: 'icmsimp', headerName: 'Icms Imp. 17%/18%'})
    columns.push({field: 'credpres', headerName: 'Créd. Pres. 8%/7.2%'})
    columns.push({field: 'notassaida', headerName: 'Notas de saída'})
    columns.push({field: 'observacoes', headerName: 'Observações'})
    return columns
}

const Apuracao = () => {

    const [state, setState] = useReducer(lockedReducer, {
        ...initial_state
    })

    return (
        <>
            <Box className='apuration-mainframe'>
                <Box sx={{ flex: .15 }} className='apuration-filter-wrapper'>
                    <Box className='apuration-filters'>
                        <InputLabel>Apuração</InputLabel>
                        <Box className='apuration-gapper'>
                            <DatePicker
                                slotProps={{ textField: { size: 'small' } }}
                                label="Dt. Inicial"
                                size="small"
                                value={dayjs(state.apuracao_ini)}
                                onChange={(e) => setState({ apuracao_ini: e.format('YYYY-MM-DD') })}
                                format='DD/MM/YYYY'
                                dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                sx={{ width: '11rem' }}
                            />
                            <DatePicker
                                slotProps={{ textField: { size: 'small' } }}
                                label="Dt. Final"
                                size="small"
                                value={dayjs(state.apuracao_end)}
                                onChange={(e) => setState({ apuracao_end: e.format('YYYY-MM-DD') })}
                                format='DD/MM/YYYY'
                                dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                sx={{ width: '11rem' }}
                            />
                        </Box>
                        <ColorButton className='apuration-submit'>
                            Apurar
                        </ColorButton>
                    </Box>
                    <Box className='apuration-filters'>
                        <InputLabel>Inventário - Comparar Saldos</InputLabel>
                        <Box className='apuration-gapper'>
                            <DatePicker
                                slotProps={{ textField: { size: 'small' } }}
                                label="Mês/Ano"
                                size="small"
                                value={dayjs(state.inventario_date)}
                                onChange={(e) => setState({ inventario_date: e.format('YYYY-MM') })}
                                format='MM/YYYY'
                                dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                sx={{ width: '11rem' }}
                            />
                        </Box>
                        <ColorButton className='apuration-submit'>
                            Comparar
                        </ColorButton>
                    </Box>
                </Box>
                <Box sx={{ flex: .15 }} className='nfsentrada-filters'>
                    <Box className='filter-items'>
                        <FormControl sx={{ width: '13rem' }} size="small">
                            <InputLabel id="demo-simple-select-label">Tipo Incentivo</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Tipo Incentivo"
                                value={state.tipoincentivo}
                                onChange={(e) => setState({ tipoincentivo: e.target.value })}
                            >
                                {
                                    Object.entries(incentivos).map(([key, value]) => (
                                        <MenuItem key={key} value={key}>{value}</MenuItem>
                                    ))
                                }

                            </Select>
                        </FormControl>
                        <TextField
                            size='small'
                            value={state.numeronf}
                            onChange={({ target }) => setState({ numeronf: target.value })}
                            label='Número NF'
                        />
                        <DatePicker
                            slotProps={{ textField: { size: 'small' } }}
                            label="Mês/Ano"
                            size="small"
                            value={dayjs(state.datefilter)}
                            onChange={(e) => setState({ datefilter: e.format('YYYY-MM') })}
                            format='MM/YYYY'
                            dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                            sx={{ width: '11rem' }}
                        />
                        <TextField
                            size='small'
                            value={state.codpro}
                            onChange={({ target }) => setState({ codpro: target.value })}
                            label='Cod. Produto'
                        />
                    </Box>
                    <Box className='filter-buttons'>
                        <ColorButton>
                            Localizar
                        </ColorButton>
                        <ColorButton onClick={() => setState(initial_state)}>
                            Limpar filtros
                        </ColorButton>
                    </Box>
                </Box>
                <Box sx={{ flex: .7, overflow:'hidden' }}>
                    <Table
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={useMemo(() => getcolumns(setState), [state.rows, state.edit])}
                        pagination={false}
                        toolbar
                        slots={{
                            filterComponent: true,
                            columnComponent: true
                        }}
                        density='compact'
                        rowHeight={30}
                    />
                </Box>
            </Box>
        </>
    )

}

export default Apuracao